// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__NZDeP","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__IH_2-"};